import { fromPairs, map, compose, tail, head, toPairs, mergeAll, toUpper } from 'ramda';
import React from 'react';
import autoBind from '../../modules/autoBind';
import powerpointReplace from '../../modules/powerpointReplace';
import { XTNA } from '../xtna';
import { Benzinger } from '../benzinger';
import utils from '../../modules/utils';

let FileSaver = null;

export default class HumanFactorsReportGenerator extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {};
  }
  componentDidMount() {
    if (FileSaver === null) {
      FileSaver = require('browser-filesaver');
    }
  }
  render() {
    return (
      <form style={{ marginBottom: '10px' }}>
        <input type='button' className='btn btn-success' onClick={this.export} value='Reporte Human Factors' disabled={!this.props.valid} />
      </form>
    );
  }
  unaccent(text) {
    text = text.replace(/á/g, 'a');
    text = text.replace(/é/g, 'e');
    text = text.replace(/í/g, 'i');
    text = text.replace(/ó/g, 'o');
    text = text.replace(/ú/g, 'u');
    text = text.replace(/ñ/g, 'n');
    text = text.replace(/Á/g, 'A');
    text = text.replace(/É/g, 'I');
    text = text.replace(/Í/g, 'E');
    text = text.replace(/Ó/g, 'O');
    text = text.replace(/Ú/g, 'U');
    text = text.replace(/Ñ/g, 'N');
    text = text.replace(/&/g, 'and');
    return text;
  }
  export() {
      //return Promise.resolve($.ajax({
      //url: this.props.consumeLicense,
      //method: 'POST',
      //}))
    return Promise.resolve(0)
    .then(() => this.props.licenseConsumed())
    .then(() => powerpointReplace(this.props.reportTemplateUrl, this.getReplacements(), [1, 2, 10]))
    .then((blob) => FileSaver.saveAs(blob, `Perfil Human Factors - ${this.unaccent(this.props.personalData.name)}.pptx`));
  }
  getReplacements() {
    const changeResultValues = ['Factor consistente', 'Factor de cambio moderado', 'Factor de cambio intenso'];
    const descriptions = ['alta consistencia', 'consistencia promedio alto', 'baja consistencia', 'muy baja consistencia']
    
    const xtna = fromPairs(map((prop) => [prop, parseInt(this.props.xtna[prop])], XTNA.props()));
    const benzinger = fromPairs(map((prop) => [prop, (this.props.benzinger[prop] < 10 ? ' ' : '') + this.props.benzinger[prop]], Benzinger.props()));
    const personal = this.props.personalData;
    const results = XTNA.getResults(xtna);

    const mapChangeToResult = (change) => changeResultValues[(change >= 2) + (change >= 4)];
    const changeResults = fromPairs(map(compose((change) =>
      [`${tail(head(change))}_CHANGE_RESULT`, mapChangeToResult(tail(change))]), toPairs(results.changes)));

    const dif = Math.abs(this.props.benzinger.L1 - this.props.benzinger.L2 * 4) + Math.abs(this.props.benzinger.A1 - this.props.benzinger.A2 * 4) + Math.abs(this.props.benzinger.I1 - this.props.benzinger.I2 * 4) + Math.abs(this.props.benzinger.V1 - this.props.benzinger.V2 * 4);
    const sum = this.props.benzinger.L2 * 4 + this.props.benzinger.A2 * 4 + this.props.benzinger.V2 * 4 + this.props.benzinger.I2 * 4;

    const benzingerResults = {
      changes: {
        'dFI 7': Math.abs(this.props.benzinger.A1 - this.props.benzinger.A2 * 4),
        'dPI 1': Math.abs(this.props.benzinger.L1 - this.props.benzinger.L2 * 4),
        'dPD 2': Math.abs(this.props.benzinger.I1 - this.props.benzinger.I2 * 4),
        'dFD 8': Math.abs(this.props.benzinger.V1 - this.props.benzinger.V2 * 4),
      },
      consistency: sum ? (1 - dif / sum) : null,
      change: dif
    };

    const fixSpacing = (num, spaces) => {
      if (num < 100) {
        return ' ' + (spaces !== 1 ? ' ' : '') + num;
      }

      return num;
    };

    personal.company = this.unaccent(personal.company);

    const stats = this.props.benzinger.adultoStats;
    const ch = utils.formatPercentage(benzingerResults.consistency);
    const pc = utils.formatPercentage;
    const adultoSum = (this.props.benzinger.A1 + this.props.benzinger.L1 + this.props.benzinger.I1 + this.props.benzinger.V1);
    const jovenSum = (this.props.benzinger.A2 + this.props.benzinger.L2 + this.props.benzinger.I2 + this.props.benzinger.V2);
    const tSum = R.sum(stats.AT);
    const tlSum = R.sum(stats.ATL);
    const aSum = R.sum(stats.AA);
    const imagen = this.props.benzinger.imagen;
    const adjectiveProperty = Benzinger.adjectiveToProperty[this.unaccent(this.props.benzinger.adjetivo).toLowerCase()];
    const textReplacements = mergeAll([{
        name: personal.name,
        company: personal.company,
        date: personal.date.format('DD/MM/YYYY'),
        age: personal.age + ' años',
        NAME: personal.name.toUpperCase(),
        COMPANY: personal.company,
        DATE: personal.date.format('DD MMMM YYYY'),
        NPROFILE: results.NProfile.join(' - '),
        APROFILE: results.AProfile.join(' - '),
        CHANGE: results.change,
        CONSISTENCY: (results.consistency !== 1 ? ' ' : '') + utils.formatPercentage(results.consistency),
        AFI: fixSpacing(this.props.benzinger.A1),
        API: fixSpacing(this.props.benzinger.L1),
        APD: fixSpacing(this.props.benzinger.I1),
        AFD: fixSpacing(this.props.benzinger.V1),
        JFI: fixSpacing(this.props.benzinger.A2 * 4),
        JPI: fixSpacing(this.props.benzinger.L2 * 4),
        JPD: fixSpacing(this.props.benzinger.I2 * 4),
        JFD: fixSpacing(this.props.benzinger.V2 * 4),
        AEX: this.props.e1,
        AIN: this.props.i1,
        JEX: this.props.e2,
        JIN: this.props.i2,
        TEX: fixSpacing(this.props.e1 + this.props.e2, 1),
        TIN: fixSpacing(this.props.i1 + this.props.i2, 1),
        ARAC: fixSpacing(this.props.benzinger.A1 + this.props.benzinger.L1),
        ACRE: fixSpacing(this.props.benzinger.V1 + this.props.benzinger.I1),
        ACON: fixSpacing(this.props.benzinger.A1 + this.props.benzinger.V1),
        APRAC: fixSpacing(this.props.benzinger.L1 + this.props.benzinger.I1),
        JRAC: fixSpacing(this.props.benzinger.A2 * 4 + this.props.benzinger.L2 * 4),
        JCRE: fixSpacing(this.props.benzinger.V2 * 4 + this.props.benzinger.I2 * 4),
        JCON: fixSpacing(this.props.benzinger.A2 * 4 + this.props.benzinger.V2 * 4),
        JPRAC: fixSpacing(this.props.benzinger.L2 * 4 + this.props.benzinger.I2 * 4),
        BCONSISTENCY: benzingerResults.consistency ? (ch.length !== 4 ? ' ' + ch : ch) : '    -',
        BCHANGE: fixSpacing(benzingerResults.change),
        JF7: pc(this.props.benzinger.A2/jovenSum), JP1: pc(this.props.benzinger.L2/jovenSum), JP2: pc(this.props.benzinger.I2/jovenSum), JF8: pc(this.props.benzinger.V2/jovenSum),
        AF7: pc(this.props.benzinger.A1/adultoSum), AP1: pc(this.props.benzinger.L1/adultoSum), AP2: pc(this.props.benzinger.I1/adultoSum), AF8: pc(this.props.benzinger.V1/adultoSum),
        TF7: pc(stats.AT[0]/tSum), TP1: pc(stats.AT[1]/tSum), TP2: pc(stats.AT[2]/tSum), TF8: pc(stats.AT[3]/tSum),
        TLF7: pc(stats.ATL[0]/tlSum), TLP1: pc(stats.ATL[1]/tlSum), TLP2: pc(stats.ATL[2]/tlSum), TLF8: pc(stats.ATL[3]/tlSum),
        AUF7: pc(stats.AA[0]/aSum), AUP1: pc(stats.AA[1]/aSum), AUP2: pc(stats.AA[2]/aSum), AUF8: pc(stats.AA[3]/aSum),
        IF7: imagen[0] !== '0' ? 'FI 7' : '', IP1: imagen[1] !== '0' ? 'PI 1' : '', IP2: imagen[2] !== '0' ? 'PD 2' : '', IF8: imagen[3] !== '0' ? 'FD 8' : '',
        ADF7: adjectiveProperty === 'FI 7' ? 'FI 7' : '',
        ADP1: adjectiveProperty === 'PI 1' ? 'PI 1' : '',
        ADP2: adjectiveProperty === 'PD 2' ? 'PD 2' : '',
        ADF8: adjectiveProperty === 'FD 8' ? 'FD 8' : '',
        EEP: this.props.benzinger.posDetNegEst[0], EED: this.props.benzinger.posDetNegEst[1], EEN: this.props.benzinger.posDetNegEst[2], EEE: this.props.benzinger.posDetNegEst[3],
        JE: this.props.benzinger.jovenExIn[0], JI: this.props.benzinger.jovenExIn[1],
        AE: this.props.benzinger.adultoExIn[0], AI: this.props.benzinger.adultoExIn[1],
        TE: this.props.benzinger.totalExIn[0], TI: this.props.benzinger.totalExIn[1],
        ADJETIVO: this.props.benzinger.adjetivo.toUpperCase(),
      },
      xtna,
      benzinger,
      fromPairs(map(map(compose(toUpper, (x) => x.toString())), toPairs(results.derivedProperties))),
      fromPairs(toPairs(results.changes).map((change) => [toUpper(head(change)), tail(change)])),
      changeResults
    ]);

    const index = (results.consistency < .75) + (results.consistency < .60) + (results.consistency < .40);
    textReplacements.CONSISTENCY_RESULT = `${utils.formatPercentage(results.consistency)} ${descriptions[index]}`

    const canvas1Array = $('canvas#' + this.props.chartsIds.xtna);
    if (!canvas1Array.length) {
      throw new Error('Canvas with id: ' + this.props.chartsIds.xtna + ' id not mounted.');
    }

    const canvas2Array = $('canvas#' + this.props.chartsIds.benzinger);
    if (!canvas2Array.length) {
      throw new Error('Canvas with id: ' + this.props.chartsIds.benzinger + ' id not mounted.');
    }

    const canvas3Array = $('canvas#' + this.props.chartsIds.xtnaTrabajo);
    if (!canvas3Array.length) {
      throw new Error('Canvas with id: ' + this.props.chartsIds.xtnaTrabajo + ' id not mounted.');
    }

    let r1 = [this.props.benzinger.A2, this.props.benzinger.L2, this.props.benzinger.I2, this.props.benzinger.V2];
    let r2 = [this.props.benzinger.A1, this.props.benzinger.L1, this.props.benzinger.I1, this.props.benzinger.V1];
    let r3 = stats.AT;
    let r4 = stats.ATL;
    let r5 = stats.AA;
    let r6 = imagen.map((x) => x === 'M' ? 1 : (x === 'N' ? -1 : 0));
    let r7 = [adjectiveProperty === 'FI 7' ? 1 : 0, adjectiveProperty === 'PI 1' ? 1 : 0, adjectiveProperty === 'PD 2' ? 1 : 0, adjectiveProperty === 'FD 8' ? 1 : 0];

    const swaps = {};

    for (let i = 0; i < 7; i++) {
      for (let j = 0; j < 4; j++) {
        let k = 22 + i*4 + j;
        swaps['image' + k + '.tiff'] = 'image21.tiff';
      }
    }

    let maxI = (arr) => {
      let ret = [0];
      for (let i = 1; i < arr.length; i++) {
        if (arr[i] > arr[ret[0]]) ret = [i];
        else if (Math.abs(arr[i] - arr[ret[0]]) < .0000001) ret.push(i);
      }
      return ret;
    };

    let minI = (arr) => {
      let ret = [0];
      for (let i = 1; i < arr.length; i++) {
        if (arr[i] < arr[ret[0]]) ret = [i];
        else if (Math.abs(arr[i] - arr[ret[0]]) < .0000001) ret.push(i);
      }
      return ret;
    };

    let assignColors = (imageIndex, values) => {
      const maxIs = maxI(values);
      let minIs = minI(values);
      if (R.equals(maxIs, minIs))
        minIs = [];

      const assignColor = (imgNum) =>
        (num) => swaps['image' + (imageIndex + num) + '.tiff'] = 'image' + imgNum + '.tiff';

      maxIs.forEach(assignColor(20));
      minIs.forEach(assignColor(19));
    };

    assignColors(22, r1);
    assignColors(26, r2);
    assignColors(30, r3);
    assignColors(34, r4);
    assignColors(38, r5);
    assignColors(42, r6);
    swaps['image' + (46 + maxI(r7)[0]) + '.tiff'] = 'image20.tiff';

    return {
      text: textReplacements,
      images: {
        'image7.png': head(canvas1Array).toDataURL().split(',')[1],
        'image8.png': head(canvas2Array).toDataURL().split(',')[1],
        'image78.png': head(canvas3Array).toDataURL().split(',')[1]
      },
      swaps
    };
  }
}



// WEBPACK FOOTER //
// ./src/App/reports/HumanFactorsReportGenerator.jsx